import React from 'react';

import Box from '@mui/material/Box';
import { Button, CircularProgress, TextField } from '@mui/material';
import { inject, observer } from 'mobx-react';
import { flowRight as compose } from 'lodash';

import styles, * as E from './styles';

class AssignmentAssign extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reason: '',
    };
  }

  componentDidUpdate(prevProps) {
    /* empty */
  }

  onUpdate = (name) => (e) => {
    if (e.target.value !== undefined) {
      this.setState({ [name]: e.target.value });
      this.props.updateReason?.(e.target.value);
    }
  };

  updateBonus = (assignment) => () => {
    /* empty */
  };

  render() {
    const { store } = this.props;
    const { assignmentStore } = store;
    const { assigning, unAssigning } = assignmentStore;

    return (
      <E.Container style={styles.Container}>
        <Box>
          <Box sx={{ display: 'flex' }}>
            <Box sx={{ flex: 1, ...styles.GroupPanel }}>
              <div style={styles.GroupField}>
                <div style={styles.Field}>
                  <TextField
                    multiline
                    rows={5}
                    variant="outlined"
                    fullWidth
                    label="Reason"
                    value={this.state.reason}
                    onChange={this.onUpdate('reason')}
                    placeholder={`Reason...`}
                  />
                </div>
              </div>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: "center", gap: 1 }}>
            <Button variant="outlined" size="small" disableElevation onClick={this.props.onClose}>
              Cancel
            </Button>
            <Button
              variant="contained"
              size="small"
              disableElevation
              onClick={assigning || unAssigning ? undefined : this.props.onClick}
              color="primary"
              disabled={assigning || unAssigning || !this.state.reason}
            >
              {(assigning || unAssigning) && <CircularProgress size={16} sx={{ mr: 0.5 }} />} Save
            </Button>
          </Box>
        </Box>
      </E.Container>
    );
  }
}
export default compose(inject('store'), observer)(AssignmentAssign);
